<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6">
          <h5>Tuition Daily Attendance</h5>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <!-- Filters -->
        <div class="row mb-3">
          <!-- Program Filter -->
          <div class="col-md-3 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedProgramId"
              placeholder="Select Program"
              show-search
              style="width: 100%"
              :filter-option="filterOption"
              @change="handleProgramChange"
            >
              <a-select-option v-for="p in programs" :key="p.id" :value="p.id">
                {{ p.name }}
                <small class="text-muted" v-if="p.code">({{ p.code }})</small>
              </a-select-option>
            </a-select>
          </div>
          <!-- Tuition Session -->
          <div class="col-md-3 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedTuitionSessionId"
              placeholder="Select Tuition Session"
              style="width: 100%"
              :disabled="!selectedProgramId"
              @change="handleSessionChange"
            >
              <a-select-option v-for="s in tuitionSessions" :key="s.id" :value="s.id">
                {{ s.name }}
              </a-select-option>
            </a-select>
          </div>
          <!-- Date -->
          <div class="col-md-3 col-12 mb-2">
            <a-date-picker
              size="large"
              style="width: 100%"
              v-model="selectedDate"
              :format="dateFormat"
              :disabled-date="disabledDate"
              @change="handleDateChange"
            />
          </div>
        </div>

        <!-- Attendance Table Component -->
        <div class="card">
          <div class="card-body">
            <tuition-attendance-table
              v-if="attendanceData"
              :loading="loading"
              :data="attendanceData.data || []"
              :sessionInfo="attendanceData.tuition_session"
              :timing="attendanceData.timing"
              :date="attendanceData.date"
              :summary="attendanceSummary"
              :filterStatus="filterStatus"
              :approveLoading="approveLoading"
              @filter-change="handleFilterChange"
              @approve="handleApprove"
            />
            <div v-else-if="!loading" class="text-center py-5">
              <a-empty description="Select a tuition session and date to view attendance" />
            </div>
            <a-spin v-else />
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import TuitionAttendanceTable from '@/components/tuition/manage/attendance/Table'

export default {
  name: 'TuitionDailyAttendanceView',
  components: {
    TuitionAttendanceTable,
  },
  beforeMount() {
    this.$roleutility.checkpermission('tuition-attendance', 22).then(data => {
      this.pagepermission = data.pagePermission
    })
  },
  data() {
    return {
      loading: false,
      approveLoading: false,
      dateFormat: 'DD-MM-YYYY',

      programs: [],
      tuitionSessions: [],
      selectedProgramId: undefined,
      selectedTuitionSessionId: undefined,
      selectedDate: moment(),
      filterStatus: 'all',

      attendanceData: null,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  computed: {
    attendanceSummary() {
      if (this.attendanceData && this.attendanceData.summary) {
        return this.attendanceData.summary
      }
      return { total: 0, present: 0, absent: 0, pending: 0 }
    },
  },
  mounted() {
    this.fetchPrograms()
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days after today
      return current && current > moment().endOf('day')
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    fetchPrograms() {
      this.$http.get('/api/tuition/programs')
        .then(({ data }) => {
          this.programs = data.data || data
        })
    },
    handleProgramChange(value) {
      this.selectedProgramId = value
      this.selectedTuitionSessionId = undefined
      this.tuitionSessions = []
      this.attendanceData = null

      if (value) {
        this.$http.get(`/api/tuition/programs/${value}/sessions`)
          .then(({ data }) => {
            this.tuitionSessions = data.data || data
          })
      }
    },
    handleSessionChange() {
      if (this.selectedTuitionSessionId && this.selectedDate) {
        this.filterStatus = 'all'
        this.fetchAttendance()
      }
    },
    handleDateChange() {
      if (this.selectedTuitionSessionId && this.selectedDate) {
        this.filterStatus = 'all'
        this.fetchAttendance()
      }
    },
    handleFilterChange(status) {
      this.filterStatus = status
      this.fetchAttendance()
    },
    fetchAttendance() {
      if (!this.selectedTuitionSessionId || !this.selectedDate) {
        this.$message.warning('Please select a tuition session and a date.')
        return
      }
      this.loading = true
      const params = {
        tuition_session_id: this.selectedTuitionSessionId,
        date: moment(this.selectedDate).format('YYYY-MM-DD'),
      }
      if (this.filterStatus && this.filterStatus !== 'all') {
        params.filter_status = this.filterStatus
      }
      this.$http.get('/api/tuition/attendance', { params })
        .then(({ data }) => {
          this.attendanceData = data
        })
        .catch(error => {
          this.$neoNotify.error(error)
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleApprove() {
      this.approveLoading = true
      this.$http.post('/api/tuition/attendance/approve', {
        tuition_session_id: this.selectedTuitionSessionId,
        date: moment(this.selectedDate).format('YYYY-MM-DD'),
      })
        .then(({ data }) => {
          this.$message.success(data.message || 'Attendance approved.')
          this.fetchAttendance()
        })
        .catch(error => {
          this.$neoNotify.error(error)
        })
        .finally(() => {
          this.approveLoading = false
        })
    },
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
